import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './Layout.css'; // Assuming you have some styles for the layout

const Layout = ({ children }) => {
    return (
        <div className="layout">
            <Header />
            <main>{children}</main>
            <Footer />
        </div>
    );
};

export default Layout;